export default {
    parts: ['container', 'starContainer', 'star', 'full'],
    baseStyle: {
        container: {
            align: 'center'
        },
        starContainer: {
            gap: '0.125rem',
            alignItems: 'center'
        },
        star: {
            width: '0.5rem',
            height: '0.5rem'
        },
        full: {
            color: 'stokkeCore.black'
        }
    },
    variants: {
        productTile: {
            starContainer: {
                display: 'flex'
            }
        },
        cockpit: {
            starContainer: {
                display: 'flex',
                height: '1.5rem'
            },
            star: {
                height: '0.875rem',
                width: '0.875rem'
            },
            container: {
                align: 'center',
                cursor: 'pointer'
            }
        },
        pdpSpec: {
            starContainer: {
                display: 'flex'
            },
            star: {
                width: '1rem',
                height: '1rem'
            }
        },
        reviewsModule: {
            starContainer: {
                display: 'flex'
            },
            star: {
                width: '1rem',
                height: '1rem'
            }
        },
        review: {
            starContainer: {
                display: 'flex'
            },
            star: {
                width: '1rem',
                height: '1rem'
            }
        }
    },
    defaultProps: {
        variant: 'baseStyle'
    }
}
